export default __webpack_public_path__ + "9fd398f86ce80d968762d962141c8d69.ttf";